import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import TelegramLoginButton from '../../components/sentry/TelegramLoginButton';
import { loginTelegram, type TelegramAuthPayload } from '../../utils/telegramAuth';

const Page = styled.div`
  min-height: 100vh;
  background: #000000;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  text-align: center;
  gap: 16px;
  font-family: 'Plus Jakarta Sans', sans-serif;
`;

const Title = styled.h1`
  font-size: 22px;
  margin: 0;
`;

const Body = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  max-width: 320px;
`;

const Status = styled.p`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
`;

const SentryTelegramHandoff: React.FC = () => {
  const handoffCode = useMemo(() => {
    if (typeof window === 'undefined') return '';
    return new URLSearchParams(window.location.search).get('handoff') || '';
  }, []);
  const [status, setStatus] = useState<string>('Connect your Telegram to continue.');
  const [error, setError] = useState<string | null>(null);
  const telegramBotUsername = (import.meta.env as any).VITE_TELEGRAM_BOT_USERNAME as string | undefined;

  const handleAuth = async (payload: TelegramAuthPayload) => {
    setError(null);
    if (!handoffCode) {
      setError('Missing handoff code. Return to the PWA and try again.');
      return;
    }

    try {
      await loginTelegram(payload, { handoffCode });
      setStatus('Login complete. Return to the Sentry PWA to finish signing in.');
    } catch (authError: any) {
      setError(authError?.message || 'Telegram login failed.');
    }
  };

  return (
    <Page>
      <Title>Connect Telegram</Title>
      <Body>Finish login in this browser, then return to the Sentry PWA.</Body>
      <TelegramLoginButton
        botUsername={telegramBotUsername}
        onAuth={handleAuth}
        size="large"
        label="Telegram"
      />
      <Status>{status}</Status>
      {error && <Status>{error}</Status>}
    </Page>
  );
};

export default SentryTelegramHandoff;
